export default "__VITE_ASSET__BtWhC9HX__"